module.exports = __webpack_public_path__ + "static/media/medal-bronze.fe469546.png";